var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-component"},[_c('picture',[_c('source',{attrs:{"media":"(max-width: 991px)","srcset":_vm.banner.imgUrlMobile}}),_c('img',{attrs:{"src":_vm.banner.imgUrl,"alt":_vm.banner.textAlt}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }